// src/lib/hooks.tsx
import { useContext } from "react";
import { StackContext } from "../providers/stack-provider-client.js";
function useUser(options = {}) {
  const stackApp = useStackApp(options);
  if (options.projectIdMustMatch && stackApp.projectId !== options.projectIdMustMatch) {
    throw new Error("Unexpected project ID in useStackApp: " + stackApp.projectId);
  }
  if (options.projectIdMustMatch === "internal") {
    return stackApp.useUser(options);
  } else {
    return stackApp.useUser(options);
  }
}
function useStackApp(options = {}) {
  if (typeof useContext !== "function") {
    throw new Error("useStackApp() can only be used in a React Client Component. Make sure you're not calling it from a Server Component, or any other environment.");
  }
  const context = useContext(StackContext);
  if (context === null) {
    throw new Error("useStackApp must be used within a StackProvider");
  }
  const stackApp = context.app;
  if (options.projectIdMustMatch && stackApp.projectId !== options.projectIdMustMatch) {
    throw new Error("Unexpected project ID in useStackApp: " + stackApp.projectId);
  }
  return stackApp;
}
export {
  useStackApp,
  useUser
};
//# sourceMappingURL=hooks.js.map